customElements.define(
  "yotpo-stars",
  class YotpoStars extends HTMLElement {
    connectedCallback() {
      this.yOffset = -100;
      this.initYotpo();
      this.addEventListener('click', this.scrollToReviews.bind(this));
    }

    initYotpo() {
      if (!window.yotpo.appKey) {
        console.error("No Yotpo APP Key configured in theme editor.");
        return;
      }

      fetch(
        `https://api.yotpo.com/products/${window.yotpo.appKey}/${this.dataset.productId}/bottomline`
      )
        .then((rawFetchResponse) => rawFetchResponse.json())
        .then((data) => {
          const { response, status } = data;

          if (status.code !== 200 || !response) {
            this.style = "display: none;";
            return;
          }

          this.classList.add('show')

          const score = response.bottomline.average_score;
          const totalReviews = response.bottomline.total_reviews;

          if (totalReviews === 0) {
            this.style = "display: none;";
            return;
          } else {
            this.style.removeProperty("display");
          }

          this.querySelector(".rate").innerHTML = `${score.toFixed(1)}`;
          this.querySelector(".reviews-count").innerHTML = `(${totalReviews})`;
          const starContainer = this.querySelector(".star");
          const starsCount = starContainer.querySelectorAll("svg").length;
          if(starsCount < 5) {
            this.showStars(score, starContainer)
          }
        });
    }

    showStars(score, starContainer) {
      const maxStarsCount = 5;
      
      for (let index = 1; index < maxStarsCount; index++) {
        if(score > index) {
          starContainer.innerHTML = starContainer.innerHTML + window.themeIcons.star
        } else {
          starContainer.innerHTML = starContainer.innerHTML + window.themeIcons.starInactive
        }
      }
    }

    scrollToReviews() {
      const productId = this.getAttribute('data-product-id');
      const productReviewsContainer = document.querySelector(`.yotpo-widget-instance[data-yotpo-product-id="${productId}"]`);
      if(!productReviewsContainer) return;
      const yPosition = productReviewsContainer.getBoundingClientRect().top + this.yOffset;
      window.scrollTo({top: yPosition, behavior: 'smooth'});
    }
  }
);

customElements.define(
  "yotpo-reviews",
  class YotpoReviews extends HTMLElement {
    connectedCallback() {
      this.page = 1;
      this.reviewsPerPage = 5;
      this.reviews = [];
      
      if (!window.yotpo.appKey) {
        console.error("No Yotpo APP Key configured in theme editor.");
        return;
      }

      this.addLoadMoreButtonEvent();
      this.fetchReviews();
    }

    getReviewsUrl() {
      return `https://api-cdn.yotpo.com/v1/widget/${window.yotpo.appKey}/products/${this.dataset.productId}/reviews.json?per_page=${this.reviewsPerPage}&page=${this.page}`;
    }

    fetchReviews() {
      const options = {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };
      const url = this.getReviewsUrl();

      fetch(url, options)
        .then((rawFetchResponse) => rawFetchResponse.json())
        .then((data) => {
          const { response, status } = data;

          if (status.code !== 200 || !response) {
            this.style = "display: none;";
            return;
          }

          const { reviews, bottomline } = response;
          this.reviews = [...this.reviews, ...reviews];

          if (this.reviews.length === 0) {
            this.style = "display: none;";
            return;
          } else {
            this.style = "display: block;";
          }

          this.renderReviewsHeader(bottomline);
          this.renderReviews(this.reviews);
          this.renderLoadMoreButton(bottomline);
        });
    }

    addLoadMoreButtonEvent() {
      this.querySelector('.load-more-button').addEventListener('click', () => {
        this.page = this.page + 1;
        this.fetchReviews();
      });
    }

    renderLoadMoreButton(bottomline) {
      const hasReviewsToLoad = (this.page * this.reviewsPerPage) < bottomline.total_review;
      if (!hasReviewsToLoad) {
        this.querySelector('.load-more-button').style = "display: none;";
        return;
      }
    }

    renderReviewsHeader(bottomline) {
      const averageScore = bottomline.average_score;
      const numOfReviews = bottomline.total_review;

      this.querySelector(".overall__container .rate").innerHTML =
        averageScore.toFixed(1);
      this.querySelector(".overall__container .description").innerHTML =
        numOfReviews === 1
          ? `Based on ${numOfReviews} Review`
          : `Based on ${numOfReviews} Reviews`;
    }

    renderReviews(reviews) {
      const reviewElements = Array.from(
        reviews.map((review) => this.getReviewElement(review))
      );
      const target = this.querySelector(".review__container");
      target.innerHTML = '';
      reviewElements.forEach((reviewEl) => {
        const hr = document.createElement("hr");

        target.appendChild(reviewEl);
        target.appendChild(hr);
      });
    }

    getReviewElement(review) {
      if (!review) {
        return null;
      }

      const authorName = review.user.display_name;
      const { score, title, content } = review;
      const MAX_SCORE = 5;

      const innerContainer = document.createElement("div");
      innerContainer.classList.add("review");
      const thumb = document.createElement("div");
      thumb.classList.add("thumb");
      thumb.innerHTML = authorName[0];

      const reviewContent = document.createElement("div");
      reviewContent.classList.add("review__content");

      const author = document.createElement("div");
      author.classList.add("author");
      author.classList.add("t-body-small");
      author.innerHTML = authorName;
      if (review.verified_buyer) {
        const verified = document.createElement("div");
        verified.classList.add("verified");
        verified.classList.add("t-body-small");
        verified.innerHTML = "Verified";
        author.appendChild(verified);
      }

      const stars = document.createElement("div");
      stars.classList.add("stars");
      const activeStars = [...Array(score).keys()]
        .map(() => window.themeIcons.star)
        .join("");
      const inactiveStars = [...Array(MAX_SCORE - score).keys()]
        .map(() => window.themeIcons.starInactive)
        .join("");
      stars.innerHTML = `${activeStars}${inactiveStars}`;
      const reviewTitle = document.createElement("div");
      reviewTitle.classList.add("review-title");
      reviewTitle.classList.add("t-5");
      reviewTitle.innerHTML = title;
      const description = document.createElement("div");
      description.classList.add("description");
      description.innerHTML = content;

      reviewContent.appendChild(author);
      reviewContent.appendChild(stars);
      reviewContent.appendChild(reviewTitle);
      reviewContent.appendChild(description);

      innerContainer.appendChild(thumb);
      innerContainer.appendChild(reviewContent);

      return innerContainer;
    }
  }
);
